<template>
    <main>
        <admin-nav-menu active-item="misc"></admin-nav-menu>
        Дополнительно
    </main>
</template>

<script>
import AdminNavMenu from './Components/AdminNavMenu.vue';

export default {
        components: {
            AdminNavMenu
        }
    }
</script>
